module.exports = __webpack_public_path__ + "static/media/SerieLHLittleGiant.65c84095.jpg";